import script from "./ResetPwdView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPwdView.vue?vue&type=script&setup=true&lang=js"

import "./ResetPwdView.vue?vue&type=style&index=0&id=73f049c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f049c8"]])

export default __exports__